











import { Component, Vue, Prop } from 'vue-property-decorator'

import FieldError from '@/components/FieldError.vue'

import ErrorEntities from '@/models/error-entities'

@Component({
  components: {
    FieldError,
  },
})
export default class FieldErrorGroup extends Vue {
  @Prop() errors!: ErrorEntities
  @Prop() errorKeys!: string[]
  @Prop({ default: '' }) prefix!: string

  // Only pick required errors if keys provided
  get filteredErrors(): ErrorEntities {
    const { errors, errorKeys } = this
    if (!errorKeys) {
      return errors
    }

    return Object.keys(errors)
      .filter((fieldName) => errorKeys.includes(fieldName))
      .reduce((res: ErrorEntities, fieldName) => {
        res[fieldName] = errors[fieldName]

        return res
      }, {})
  }

  // Returns { errorMessage: "field1, field2 and field3" }
  get groupedErrors(): { [errorMessage: string]: string } {
    const { filteredErrors } = this

    return this.$_.chain(filteredErrors)
      .keys()
      .reduce((res: { [errorMessage: string]: string[] }, fieldName: string): {
        [errorMessage: string]: string[]
      } => {
        filteredErrors[fieldName].forEach((errorMessage) => {
          res[errorMessage] = res[errorMessage] || []
          res[errorMessage].push(this.$_.startCase(fieldName))
        })

        return res
      }, {})
      .mapValues((fieldNames): string => {
        if (fieldNames.length <= 1) {
          return fieldNames[0]
        }

        const lastField = fieldNames.pop()
        const joinedFields = fieldNames.join(', ')

        return `${joinedFields} and ${lastField}`
      })
      .value()
  }
}
